<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapState, mapGetters, mapActions } from "vuex";
import Swal from "sweetalert2";
import { ModelListSelect } from "vue-search-select";
import moment from "moment";


/**
 * Advanced table component
 */
export default {
  page: {
    title: "Local Purchase Orders",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
  },
  data() {
    return {
      title: "Local Purchase Orders",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Local Purchase Orders",
          active: true,
        },
      ],
      totalRows: 1,

      pageOptions: [10, 25, 50, 100, 200, 1000],
      serverPerPage: 10,
      IsServerPaginated: true,
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",

      delete: {
        id: "",
        supplier: "",
      },
      filterLPOs: {
        supplier_id: "",
        product_id: "",
        datefrom: moment().subtract(1, 'months').format('YYYY-MM-DD'),
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        page: 1,
        per_page: 10,
      },
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", ["type", "message", "show"]),
    ...mapGetters("stock", [
      "LPOs",
      "SaveStatus",
      "filterStatus",
      "LPOsPagination",
      "Suppliers",
    ]),
    ...mapGetters("sales", ["Products"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.IsServerPaginated
        ? this.LPOsPagination.total
        : this.LPOs
        ? this.LPOs.length
        : 0;
    },

    currentPage: {
      get() {
        return this.IsServerPaginated
          ? this.LPOsPagination.current_page
          : this.clientCurrentPage;
      },
      set(value) {
        if (this.IsServerPaginated) {
          this.handlePageChange(value);
        } else {
          this.clientCurrentPage = value;
        }
      },
    },

    perPage: {
      get() {
        return this.IsServerPaginated
          ? this.LPOsPagination.per_page
          : this.clientPerPage;
      },
      set(value) {
        if (this.IsServerPaginated) {
          this.serverPerPage = value;
          this.filterLPOs.per_page = value;
          this.filterLPOs.page = 1;
          this.FilterLPOs();
        } else {
          this.clientPerPage = value;
        }
      },
    },

    /**
     * Todo list of records
     */
  },

  watch: {
    show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.closeModal(this.modal_id);
        if (this.type == "success") {
          Swal.fire("Success!", this.message.msg, "success");
          // this.$toast.success(this.message.msg);
        } else {
          // this.$toast.error(this.message.msg);
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchLPOs: "stock/fetchLPOs",
      Delete: "stock/deleteAllLPO",
      FetchSuppliers: "stock/fetchSuppliers",
      FetchItems: "sales/fetchItems",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered() {
      if (!this.IsServerPaginated) {
        this.clientCurrentPage = 1;
      }
    },

    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/[^0-9.]+/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    redirect(value) {
      this.$router.push(`/lpo/print/${btoa(value)}`);
    },
    redirect1(value) {
      this.$router.push(`/lpo/details/${btoa(value)}`);
    },

    SetdeleteData(data) {
      (this.delete.id = data.id),
        (this.delete.supplier =
          data.supplierobj.name + "-" + data.supplierobj.contact);
    },

    DeleteLPO(modalId) {
      this.Delete(this.delete.id);
      this.closeModal(modalId);
    },

    resetDelete() {
      (this.delete.id = ""), (this.delete.supplier = "");
    },

    closeModal(modalId) {
      this.resetDelete();
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },

    handlePageChange(newPage) {
      if (this.IsServerPaginated) {
        let payload = {
          ...this.filterLPOs,
          page: newPage,
          per_page: this.serverPerPage,
        };
        this.filterLPOs.page = newPage;
        this.FetchLPOs(payload);
      }
    },

    FilterLPOs() {
      this.filterLPOs.page = 1;
      this.filterLPOs.per_page = this.serverPerPage;
      this.FetchLPOs(this.filterLPOs);
    },

    ClearFilters() {
      this.filterLPOs = {
        supplier_id: "",
        product_id: "",
        datefrom: "",
        dateto: "",
        page: 1,
        per_page: this.serverPerPage,
      };
      this.FilterLPOs();
    },
  },
  created() {
    this.FetchSuppliers();
    this.FetchItems();
    this.FilterLPOs();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                <h4 class="card-title">All Generated LPOs</h4>
              </div>
              <div
                class="col-md-3"
                align="right"
                v-if="BranchData.BranchId != 0"
              >
                <router-link to="/lpo/new"
                  ><b-button variant="primary"
                    ><i class="fa fa-plus"></i> Generate New</b-button
                  ></router-link
                >
              </div>
            </div>

            <!-- Filters Section -->
            <div class="row mt-4 mb-4">
              <div class="col-sm-3 col-md-3 form-group">
                <label>FILTER BY SUPPLIER</label>
                <model-list-select
                  :list="
                    Suppliers
                      ? [{ id: '', name: 'All Suppliers' }, ...Suppliers]
                      : []
                  "
                  v-model="filterLPOs.supplier_id"
                  option-value="id"
                  option-text="name"
                  placeholder="Select Supplier"
                  @input="FilterLPOs()"
                >
                </model-list-select>
              </div>

              <div class="col-sm-3 col-md-3 form-group">
                <label>FILTER BY PRODUCT</label>
                <model-list-select
                  :list="
                    Products
                      ? [{ id: '', name: 'All Products' }, ...Products]
                      : []
                  "
                  v-model="filterLPOs.product_id"
                  option-value="id"
                  option-text="name"
                  placeholder="Select Product"
                  @input="FilterLPOs()"
                >
                </model-list-select>
              </div>

              <div class="col-sm-3 col-md-3 form-group">
                <label>FROM DATE</label>
                <input
                  type="date"
                  class="form-control"
                  v-model="filterLPOs.datefrom"
                />
              </div>

              <div class="col-sm-3 col-md-3 form-group">
                <label>TO DATE</label>
                <input
                  type="date"
                  class="form-control"
                  v-model="filterLPOs.dateto"
                />
              </div>
            </div>

            <!-- Date Range Filter Row -->
            <div class="row mb-4">
                  <div class="col-sm-12 col-md-4">
                    <div id="tickets-table_length" class="dataTables_length">
                      <label class="d-inline-flex align-items-center">
                        Show&nbsp;
                        <b-form-select
                          class="form-select form-select-sm"
                          v-model="perPage"
                          @change="onExpectedPerPageChange"
                          size="sm"
                          :options="pageOptions"
                        ></b-form-select
                        >&nbsp;entries
                      </label>
                    </div>
                  </div>                

               <div class="col-sm-3 col-md-2 form-group d-flex align-items-end">
                <button class="btn btn-primary me-2" @click="FilterLPOs">
                  <span class="fa fa-filter"></span> Filter
                  <b-spinner
                    v-show="filterStatus"
                    variant="light"
                    small
                    role="status"
                  ></b-spinner>
                </button>
                <b-button variant="secondary" @click="ClearFilters()">
                  <i class="fa fa-refresh"></i> Clear
                </b-button>
              </div>
            </div>
           
            <!-- Table -->
            <div class="table-responsive mb-0 mt-2">
              <table
                class="table table-striped table-bordered table-responsive nowrap w-100 datatables"
              >
                <thead>
                  <tr>
                    <th>S/N</th>
                    <th>SUPPLIER</th>
                    <th>PRODUCTS</th>
                    <th>DATE</th>
                    <th>USER</th>
                    <th>TOTAL</th>
                    <th>PAID</th>
                    <th>BALANCE</th>
                    <th>ACTIONS</th>
                  </tr>
                </thead>

                <tbody v-if="!filterStatus && LPOs && LPOs.length > 0">
                  <tr v-for="(item, index) in LPOs" :key="item.id">
                    <td>{{ LPOsPagination.from + index }}</td>
                    <td>
                      {{ item.supplier?item.supplier:'' }}
                    </td>
                    <td>{{ item.items }} products</td>
                    <td>{{ item.dateAdded }}</td>
                    <td>{{ item.user }}</td>
                    <td>{{ item ? thousandSeperator(item.totAmt) : 0 }}</td>
                    <td>{{ item ? thousandSeperator(item.paid) : 0 }}</td>
                    <td>
                      {{
                        item ? thousandSeperator(item.totAmt - item.paid) : 0
                      }}
                    </td>
                    <td>
                      <b-button-group>
                        <b-button
                          size="sm"
                          variant="primary"
                          @click="redirect1(item.id)"
                          ><i class="fa fa-eye"></i> View</b-button
                        >
                        <b-button
                          size="sm"
                          variant="success"
                          @click="redirect(item.id)"
                          ><i class="fa fa-print"></i> Print</b-button
                        >
                        <b-button
                          size="sm"
                          variant="danger"
                          v-b-modal.delete-modal
                          @click="SetdeleteData(item)"
                          ><i class="fa fa-trash"></i> Delete</b-button
                        >
                      </b-button-group>
                    </td>
                  </tr>
                </tbody>

                <!-- Loading -->
                <tbody v-if="filterStatus">
                  <tr>
                    <td :colspan="12" class="text-center">
                      <div class="text-warning my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                      </div>
                    </td>
                  </tr>
                </tbody>
                <!-- No data -->
                <tbody v-if="!filterStatus && (!LPOs || LPOs.length === 0)">
                  <tr>
                    <td :colspan="12" class="text-center">No LPOs found.</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>

            <!-- Delete Model -->
            <b-modal id="delete-modal" hide-footer @hidden="resetDelete()">
              <template #modal-title>
                <h4 class="text-danger">
                  Your are deleting this LPO
                </h4></template
              >

              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                  @click="closeModal('delete-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                  type="button"
                  class="btn btn-danger"
                  @click="DeleteLPO('delete-modal')"
                >
                  <i class="fa fa-trash"></i> Delete
                  <b-spinner
                    v-if="SaveStatus"
                    variant="light"
                    small
                    label="Submiting"
                  ></b-spinner>
                </button>
              </div>
            </b-modal>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.btn-primary,
.page-link {
  background-color: #fab031 !important;
  border-color: #fab031 !important;
}
.btn-xs {
  padding: 0.25rem 0.4rem;
  font-size: 0.875rem;
  line-height: 0.5;
  border-radius: 0.2rem;
}
</style>
